/*
 * Branded Best: in-hands and approve-by dates, shared by the company orders page (bb-company-order.js) and the
 * in-hands date on product pages (bb-inhand.js). Pure functions only, no DOM. Exposed as window.BBDates, and as
 * module.exports for node tests.
 *
 * Dates are plain 'YYYY-MM-DD' strings, computed in UTC so daylight saving never moves a day.
 * The earliest in-hands date we promise is EARLIEST_DAYS from today, every day of the year (Nick, 2026-10-28: "Make
 * this 45 days out from today's date always"). It replaced next business day + 42, plus two weeks for dates from
 * Nov 15 to Jan 15: there are no busiest weeks any more, so inSeason() is always false.
 * Approve-by = in-hands - LEAD_DAYS.
 */
(function (root) {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var LEAD_DAYS = 42; // approve the proof this many days before the in-hands date
  var EARLIEST_DAYS = 45; // the earliest in-hands date we promise, counted from today
  var SEASON_DAYS = 0; // the busiest weeks' two extra weeks, retired 2026-10-28

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function trim(s) { return String(s == null ? '' : s).trim(); }
  function ymd(y, m0, d) { return y + '-' + pad(m0 + 1) + '-' + pad(d); }
  function parseISO(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trim(s));
    if (!m) return null;
    var y = +m[1], mo = +m[2] - 1, d = +m[3];
    var dt = new Date(Date.UTC(y, mo, d));
    if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== mo || dt.getUTCDate() !== d) return null;
    return dt;
  }
  function toISO(dt) { return ymd(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate()); }
  function addDays(iso, n) {
    var d = parseISO(iso);
    if (!d) return '';
    d.setUTCDate(d.getUTCDate() + n);
    return toISO(d);
  }
  // A date i months later; the day is kept, or clamped to the last day of a shorter month.
  function addMonths(iso, i) {
    var d = parseISO(iso);
    if (!d) return '';
    var mm = d.getUTCMonth() + i;
    var y = d.getUTCFullYear() + Math.floor(mm / 12), m = ((mm % 12) + 12) % 12;
    var last = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
    return ymd(y, m, Math.min(d.getUTCDate(), last));
  }
  // "Oct 20, 2026"
  function fmtDate(iso) {
    var d = parseISO(iso);
    return d ? MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear() : '';
  }
  // "Tue, Oct 20"
  function fmtDay(iso) {
    var d = parseISO(iso);
    return d ? DAYS[d.getUTCDay()] + ', ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate() : '';
  }
  function todayISO(now) {
    var d = now || new Date();
    return ymd(d.getFullYear(), d.getMonth(), d.getDate());
  }
  // Our busiest weeks (Nov 15 to Jan 15) no longer need extra time (Nick, 2026-10-28: "always").
  function inSeason() {
    return false;
  }
  // The first weekday after today (Friday → Monday).
  function nextBusinessDay(iso) {
    var x = addDays(iso, 1);
    var dow = parseISO(x).getUTCDay();
    if (dow === 6) return addDays(x, 2);
    if (dow === 0) return addDays(x, 1);
    return x;
  }
  function approveByDate(inhand) {
    if (!parseISO(inhand)) return '';
    return addDays(inhand, -LEAD_DAYS - (inSeason(inhand) ? SEASON_DAYS : 0));
  }
  // We can promise a date EARLIEST_DAYS or more from today.
  function canPromise(inhand, today) {
    return !!parseISO(inhand) && inhand >= addDays(today, EARLIEST_DAYS);
  }
  // The earliest date we can promise at all.
  function earliestInhand(today) {
    return addDays(today, EARLIEST_DAYS);
  }
  // The first date we can promise on or after the one picked.
  function earliestFrom(base, today) {
    var e = earliestInhand(today);
    return !parseISO(base) || base <= e ? e : base;
  }

  var api = {
    MONTHS: MONTHS, LEAD_DAYS: LEAD_DAYS, EARLIEST_DAYS: EARLIEST_DAYS, SEASON_DAYS: SEASON_DAYS,
    pad: pad, trim: trim, ymd: ymd, parseISO: parseISO, toISO: toISO, addDays: addDays, addMonths: addMonths,
    fmtDate: fmtDate, fmtDay: fmtDay, todayISO: todayISO, inSeason: inSeason, nextBusinessDay: nextBusinessDay,
    approveByDate: approveByDate, canPromise: canPromise, earliestInhand: earliestInhand, earliestFrom: earliestFrom
  };
  if (root) root.BBDates = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : this);
